/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import template from './advertiser-item-page.component.html';

import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {AdvertiserModel} from './advertiser-api.service';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';
import {AdvertiserEditPageComponent} from './advertiser-edit-page.component';
import {AdvertiserAnalysisPageComponent} from './advertiser-analysis-page.component';
import {AdvertiserInformationPageComponent} from './advertiser-information-page.component';

@Component({
  standalone: true,
  imports: [
    ...ADVERTISING_SHARED,
    AdvertiserEditPageComponent,
    AdvertiserAnalysisPageComponent,
    AdvertiserInformationPageComponent
  ],
  selector: 'adn-advertiser-item-page',
  template
})
export class AdvertiserItemPageComponent {
  @Input() state: SignalAdminResourcePageState<AdvertiserModel>;
}
